<template>
    <ImageSlider/>
    <div>
        <h2 class="text-start offset-md-2 offset-1 mt-3 mb-3 fw-bold">NOVICE</h2>
        <News/>
    </div>
</template>

<script>

import ImageSlider from '../components/ImageSlider.vue'
import News from '../components/News.vue'

export default {
    name: "Home",
    components:{
        ImageSlider,
        News
    }
}
</script>